"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Modal = require("@insided/shared/uikit/Modal");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var MarkAsSpamModal = function MarkAsSpamModal(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      isOpen = _ref.isOpen,
      onMarkAsSpam = _ref.onMarkAsSpam,
      _onClose = _ref.onClose;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: (0, _preact.h)(_phrase.default, {
      p: title
    }),
    onClose: function onClose() {
      return _onClose();
    }
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
    className: "mark-as-spam-modal"
  }, (0, _preact.h)(_phrase.default, {
    p: subTitle
  }))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "frontend_moderation.mark_as_spam"
    }),
    onClick: function onClick() {
      return onMarkAsSpam(false);
    },
    size: "medium",
    variant: "warning",
    "data-qa": "confirm-mark-as-spam",
    "data-track-type": "click",
    "data-element-name": "Mark as spam button"
  }), (0, _preact.h)(_Button.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "frontend_moderation.mark_as_spam_and_ban_the_user"
    }),
    onClick: function onClick() {
      return onMarkAsSpam(true);
    },
    size: "medium",
    variant: "warning",
    "data-qa": "confirm-mark-as-spam-and-ban",
    "data-track-type": "click",
    "data-element-name": "Mark as spam and ban the user button"
  }), (0, _preact.h)(_Button.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "frontend_moderation.cancel"
    }),
    onClick: _onClose,
    size: "medium",
    "data-track-type": "click",
    "data-element-name": "Cancel mark as spam button"
  })));
};

var _default = MarkAsSpamModal;
exports.default = _default;